import firebase from "firebase/app";
import "firebase/auth";
import {frontEndConfig} from "../../../config/config";
import {AppError, ErrorType} from "../../../domain/model/app_error";

const errorCode: string = frontEndConfig.errorCodeForFrontEnd;

const getToken = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        const authUser: firebase.User | null = firebase.auth().currentUser;
        if (authUser) {
            authUser
                .getIdToken(false)
                .then((token: string): void => {
                    resolve(token);
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        } else {
            reject(
                new AppError(
                    errorCode,
                    ErrorType.TOKEN_ERROR,
                    "エラーが発生しました。ページを再読み込みしてください"
                )
            );
        }
    });
};

export {getToken};



// WEBPACK FOOTER //
// ./src/infra/api/service/bind_token.ts